export default __webpack_public_path__ + "static/media/boo-negative.bc8a2baf.png";